const maxPages = 8

const state = () => ({
    routeMap: {},
    navList: [],
    pages: [],
    focusPage: '',
    currIndex: null
})

const getters = {
    routeMap: (state) => state.routeMap,
    pages: (state) => state.pages,
    focusPage: (state) => state.focusPage,
    currIndex: (state) => state.currIndex
}

const mutations = {
    setNavList: function ($this, navList) {
        $this.navList = navList
    },
    setRouteMap: function ($this, routes) {
        $this.routeMap = routes
    },
    setPage: function ($this, item) {
        $this.focusPage = item.menuName
        for (let index in $this.pages) {
            if (item.menuCode === $this.pages[index].menuCode) {
                $this.currIndex = parseInt(index)
                return
            }
        }

        if ($this.pages.length >= maxPages) {
            $this.pages.splice($this.pages.length - 1, 1)
        }

        $this.pages.unshift(item)
        $this.currIndex = 0
    },
    removePage: function ($this, name) {
        const index = $this.pages.findIndex(page => page.menuName === name)
        if (index !== -1) {
            $this.pages.splice(index, 1)
            if (index > 0) {
                window.selectNav($this.pages[index - 1])
            } else if ($this.pages[index]) {
                window.selectNav($this.pages[index])
            } else {
                window.turnBack()
            }
        }
    },
    removeLeftPages: function ($this, name) {
        const index = $this.pages.findIndex(page => page.menuName === name)
        $this.pages = $this.pages.slice(index)

        if ($this.currIndex < index) {
            $this.currIndex = 0
        } else {
            $this.currIndex -= index
        }
        window.selectNav($this.pages[$this.currIndex])
    },
    removeRightPages: function ($this, name) {
        const index = $this.pages.findIndex(page => page.menuName === name)
        $this.pages = $this.pages.slice(0, index + 1)

        if ($this.currIndex > index) {
            $this.currIndex = index
            window.selectNav($this.pages[index])
        }
    },
    removeOtherPages: function ($this, item) {
        $this.pages = []
        window.selectNav(item)
    },
    removeAllPages: function ($this) {
        $this.pages = []
        $this.focusPage = ''
    }
}

const actions = {}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/etao.js